<template>
  <div id="app" class="unselectable">
    <router-view ></router-view>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import jwtDecode from 'jwt-decode';

import axios from 'axios';

const { version } = require('../package.json');

export default {
  // watch: {
  //   wifiCamConnected: {
  //     handler(val, oldVal) {
  //       console.log('wifiCamConnected changed', val, oldVal);
  //       // if (val){

  //       }
  //     },
  //   },
  // },
  created() {
    document.title = `FlipAIoT ${version}`;
  },
  data() {
    return {
      wifiCamFetch: null,
    };
  },
  mounted() {
    this.updateDeviceList();
    console.log('Update Date: 2021/09/27');
    if (localStorage.getItem('token')) {
      const userData = jwtDecode(localStorage.getItem('token'));
      console.log(userData);
      this.setUserData(userData);
    }
    navigator.mediaDevices.ondevicechange = () => {
      console.log('on device change');
      this.updateDeviceList();
    };
    // Scan wifi cam is exist or not
    this.wifiCamFetch = setInterval(this.wifiCameraFetch, 5000);
  },
  methods: {
    ...mapMutations(['setUserData', 'updatecameraSource', 'updateWifiCameraSource']),
    async updateDeviceList() {
      let cameraSource = await navigator.mediaDevices.enumerateDevices();
      cameraSource = cameraSource.filter((device) => device.kind === 'videoinput');
      cameraSource = cameraSource.map((device) => {
        const source = {
          label: device.label === '' ? 'Camera' : device.label,
          device,
        };
        return source;
      });
      this.updatecameraSource(cameraSource);
    },

    async wifiCameraFetch() {
      axios.get('http://192.168.4.1:81/alive',
        {
          headers: {
            'Content-Type': '*/*',
          },
        })
        .then(() => {
          this.updateWifiCameraSource(true);
        })
        .catch((err) => {
          this.updateWifiCameraSource(false);
          console.log(err);
        });
    },
  },
  computed: {
    ...mapState(['wifiCamConnected']),
  },
  components: {},
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";

// #app {
//   overflow: scroll;
//   font-family: "Avenir", Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: white;
//   background-color: rosybrown;
//   // ! Jim自己加的 不是非常確定要不要加
//   line-height: 1;
// }

body {
  user-select: none;
  // overflow: scroll;
  font-family: Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  background-color: black;

  // ! Jim自己加的 不是非常確定要不要加
  line-height: 1;
  // overflow-y: hidden;

  ::-webkit-scrollbar {
    width: 0 !important;
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #9b9c9e;
  }

  .pointer {
    cursor: pointer;
  }
  ol,
  ul {
    list-style: none;
    padding:0px;
    margin:0px;
  }
  .banner {
    justify-items: flex-start;
    width: 100%;
    // height: 46px;
    margin-bottom: 40px;
  }
  .not-allowed {
    cursor: not-allowed;
  }

  button:focus {
    outline: none;
  }
}
</style>
